import isFunction from 'lodash/isFunction';
import isPlainObject from 'lodash/isPlainObject';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

export default function buildComponent({
  nameSpace = 'base-module',
  selector = `.${nameSpace}`,
  defaultParams = {
    componentName: nameSpace,
  },
  initState = {},
  initFunction = ($el, params) => ({ componentName: params.componentName }),
  } = {}) {
  function init({
    $el = document.querySelector(selector),
    customParams = {},
    props = {},
  } = {}) {
    if (!$el) {
      return $el;
    }

    const params = {
      ...defaultParams,
      ...customParams,
      props,
    };

    const stateHistory = [Object.assign({}, initState)]
    // console.log(stateHistory);

    let observers = [];

    // Hooks
    let propsUpdateHook;
    let stateUpdateHook;

    //
    // Methods
    //

    params.getState = () => Object.assign({}, stateHistory[stateHistory.length - 1]);

    params.setState = (inp = () => ({}), callback = () => undefined) => {
      let fn = () => ({});

      // Transform object to function
      if (isPlainObject(inp)) fn = () => (inp);
      // Only objects and functions allowed
      else if (isFunction(inp)) fn = inp;

      const lastState = params.getState();
      const st = fn(lastState);

      // The params.setState function return must be a plain object
      if (!isPlainObject(st)) return lastState;

      const newState = params.getState();
      for (var key in st) {
        if (st.hasOwnProperty(key) && typeof newState[key] !== 'undefined') {
          newState[key] = st[key];
        }
      }

      if (!isEqual(newState, params.getState())) {
        stateHistory.push(newState);
        // console.log(stateHistory);
        // console.log(newState);
        if (stateUpdateHook) stateUpdateHook(params.getState(), lastState);
        observers.forEach(observer => observer(params.getState()));
      }
      callback(params.getState());
      return params.getState();
    }

    params.onStateUpdate = (fn) => stateUpdateHook = fn;

    params.onPropsUpdate = (fn) => propsUpdateHook = fn;

    let obj = initFunction($el, params);

    if (typeof obj === 'undefined') {
      obj = {};
    }

    if (typeof obj.$el === 'undefined') {
      obj.$el = $el;
    }

    if (!isEmpty(params.props)) {
      obj.updateProps = (newProps) => {
        if (
          isPlainObject(newProps) &&
          isFunction(propsUpdateHook) &&
          !isEqual(newProps, params.props)
        ) {
          for (var key in newProps) {
            if (newProps.hasOwnProperty(key) && typeof params.props[key] !== 'undefined') {
              params.props[key] = newProps[key];
            }
          }
          propsUpdateHook(params.props);
        }
      }
    }

    obj.addObserver = (fn) => (isFunction(fn) && observers.push(fn));
    obj.removeObserver = (fn) => observers = observers.filter(observer => !isEqual(observer, fn));

    // Storing Component in DOM element
    // Every element can have multiple components
    if (typeof $el.Component === 'undefined') {
      $el.Component = {
        [params.componentName]: obj,
      }
    } else {
      $el.Component[params.componentName] = obj;
    }

    return obj;
  }

  function initAll(initRoot = document, config = {}) {
    const instances = [...initRoot.querySelectorAll(selector)].reduce((acc, $el) => [...acc, init({ $el })], []);
    return instances.length ? instances : undefined;
  }

  return {
    init,
    initAll,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/utils/build-component.js